import axiosInstance from "../../../helpers/api";

export const getEnrolledCourses = (body) => {
  return axiosInstance.get("/student/courses/enrolled", body);
};
export const getPendingCourses = (body) => {
  return axiosInstance.get("/student/courses/pending", body);
};

export const enrolledCourse = (body) => {
  return axiosInstance.post(
    `/student/courses/enroll?user_id=${body?.student_id}`,
    body
  );
};

export const getCourses = (body) => {
  return axiosInstance.get("/student/courses", body);
};
